import Promise from 'promise-polyfill'

const Dashboard = {
  namespaced: true,
  mutations: {
    reset: (state, payload) => {
    }
  },
  actions: {
    getDraftedRealization: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.dashboard.getDraftedRealizationUsingGET()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getDraftedRequest: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.dashboard.getDraftedRequestUsingGET()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getToggleDashboard: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.dashboard.toggleEnableDashboardUsingGET()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getWaitingApprovalRealization: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.dashboard.getWaitingApprovalRealizationUsingGET()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getWaitingApprovalRequest: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.dashboard.getWaitingApprovalRequestUsingGET()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getWaitingRealization: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.dashboard.getWaitingRealizationUsingGET()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getWaitingReleaseFunds: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.dashboard.getWaitingReleaseFundsUsingGET()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    reset: (context, payload) => context.commit('reset', payload)
  }
}
export default Dashboard



// WEBPACK FOOTER //
// ./src/store/master/Dashboard.js